import React, { useRef } from "react";
import { Link } from "react-router-dom";
import methodModel from "../../../methods/methods";
import Sidebar from "../sidebar";
import { Menu, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import { FaRegUser } from "react-icons/fa";
import { IoSettingsOutline } from "react-icons/io5";
import { FiMenu, FiX, FiLogOut, FiChevronDown, FiUser } from "react-icons/fi";
import ApiClient from "./../../../methods/api/apiClient";
import { useNavigate } from "react-router-dom";
import { SidebarItems } from "../../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import NotificationBell from "../../../pages/NotificationBell/NotificationBell";

const Html = ({
  isOpen,
  toggle,
  searchHandle,
  search,
  user,
  unreadCount,
  isOpen1,
  searchChange,
  clear,
  Logout,
  setIsOpen,
}) => {
  const Navigate = useNavigate();
  const SubsciptionData = useSelector((state) => state.Subscription);

  const PlanFeatureAvailable = (feature = "") => {
    let data = SubsciptionData;
    return data?.includes(feature);
  };
  const WebDetails = useSelector((state) => state.logo);
  const [AllNotifications, setAllNotifications] = useState([]);
  const [NotificationCount, setNotificationCount] = useState(0);
  const CurrentServer = true;
  const [PinnedStates, setPinnedStates] = useState(null);
  useEffect(() => {
    if (user?.pinnedTabs && CurrentServer) {
      setPinnedStates([...user?.pinnedTabs]);
    } else {
      setPinnedStates([]);
    }
  }, [user]);
  const PathName = window.location.pathname;

  const [isChatbotVisible, setIsChatbotVisible] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const handleNotificationToggle = () => {
    setNotificationOpen((prev) => !prev);
  };
  const notificationRef = useRef(null);

  // Close notification panel when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target) &&
        notificationOpen
      ) {
        setNotificationOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [notificationOpen, setNotificationOpen]);

  const handleToggleVisibility = () => {
    setIsChatbotVisible((prev) => !prev);
  };

  const handleCloseChatbot = () => {
    setIsChatbotVisible(false);
  };

  const history = useNavigate();

  const GetSidebarData = (data) => {
    SidebarItems?.find((item) => {
      if (item?.name == data) {
        return item?.icon || item?.name;
      }
    });
  };
  const logo = () => {
    let value = WebDetails?.logo;
    return value;
  };
  const logos = () => {
    let value = "/assets/img/logo.png";
    return value;
  };

  const [AccessedAccount, setAccessedAccount] = useState([]);
  const GetAccountsAccess = () => {
    ApiClient.get(`api/user/account/access?id=${user?._id || user?.id}`).then(
      (res) => {
        if (res?.success) {
          setAccessedAccount(res?.data);
        }
      },
    );
  };

  const LoggedInUser = methodModel.CookieUtil.getCookie("loggedInUser")
    ? JSON.parse(methodModel.CookieUtil.getCookie("loggedInUser"))
    : {};
  return (
    <nav
      className={`${isOpen ? "w-[calc(100%_-_0px)]" : "w-[calc(100%_-_280px)]"} header-class shadow-btn py-1.5 bg-white  fixed transition-[width] gap-2 duration-300 ml-auto right-0 z-50 flex-col  items-center !px-5 
      `}
    >
      <div className="flex items-center justify-end gap-2">
        {/* <div className="flex items-center">
          <button
            onClick={toggle}
            className="h-9 w-9 shrink-0 shadow-btn hover:shadow-none p-1 rounded-lg border border-gray-100 !text-[#115B9D]  ">
            {isOpen ? (
              <FiMenu className="w-full h-full" />
            ) : (
              <FiX className="w-full h-full" />
            )}
          </button>
        </div> */}
        <NotificationBell />
        <div>
          <Menu as="div" className="relative z-10 flex items-center">
            <div className="flex items-center gap-0">
              <Menu.Button className="hover:bg-black/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 rounded-large flex items-center justify-center w-full gap-2 px-2 py-2">
                <img
                  alt="image"
                  src={methodModel.userImg(user.image)}
                  className="object-cover min-w-9 w-9 h-9 rounded-full"
                  width="40"
                  height="40"
                />
                <div>
                  <p className="capitalize font-medium text-[#2D3036] text-xs sm:text-sm">
                    {user.fullName}
                  </p>
                </div>
                <FiChevronDown className="w-5 h-5 text-[#2D3036]" />
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 top-12 z-[9999] mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="py-1">
                  <Menu.Item>
                    <Link
                      to={
                        user?.role?.name == "Affiliate"
                          ? "/affiliate/profile"
                          : "/profile"
                      }
                      className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                    >
                      <FiUser className="h-[18px] min-w-[18px] w-[18px]" />
                      Profile
                    </Link>
                  </Menu.Item>
                  <div className="border-t my-1"></div>
                  <Menu.Item>
                    <button
                      onClick={() => Logout()}
                      className="flex w-full items-center gap-2 px-4 py-2 text-sm text-red-600 hover:bg-gray-100 transition-colors"
                    >
                      <FiLogOut className="h-[18px] min-w-[18px] w-[18px]" />
                      Logout
                    </button>
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      </div>
    </nav>
  );
};

export default Html;
